import { Instance } from 'mobx-state-tree';
import { ProjectUnscheduledStopsDeletedDtoModelBase } from './ProjectUnscheduledStopsDeletedDtoModel.base';

/* The TypeScript type of an instance of ProjectUnscheduledStopsDeletedDtoModel */
export interface ProjectUnscheduledStopsDeletedDtoModelType extends Instance<typeof ProjectUnscheduledStopsDeletedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectUnscheduledStopsDeletedDtoModel */
export {
  selectFromProjectUnscheduledStopsDeletedDto,
  projectUnscheduledStopsDeletedDtoModelPrimitives,
  ProjectUnscheduledStopsDeletedDtoModelSelector,
} from './ProjectUnscheduledStopsDeletedDtoModel.base';

/**
 * ProjectUnscheduledStopsDeletedDtoModel
 *
 * Unscheduled stops bulk deletion
 */
export const ProjectUnscheduledStopsDeletedDtoModel = ProjectUnscheduledStopsDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
